import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.irSubScenes.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.irSubScenes.actionsLoading;
export const getItems = (state:RootState) => state.irSubScenes.items;
export const getItemsSelect = (state:RootState) => state.irSubScenes.dropDownItems;
export const getItemsCount = (state:RootState) => state.irSubScenes.itemsCount;
export const getItemForEdit = (state:RootState) => state.irSubScenes.itemForEdit;
export const getError = (state:RootState) => state.irSubScenes.error;
export const getErrorAction = (state:RootState) => state.irSubScenes.errorAction;
export const validationErrors = (state: RootState) => state.irSubScenes.validationErrors;
